<template>
<div>
  <div class="columns" v-for="section in sectionsWithFindings" :key="section.id">
    <div class="column">
      <h4 class="title is-5 has-text-primary">{{ section.title }}</h4>
      <!-- <div class="block" v-if="section.description">
        <p class="has-text-grey">{{ section.description }}</p>
      </div> -->
      <div v-for="(checkpoint, index) in section.checkpoints" :key="checkpoint.id">
        <checkpoint-findings 
          :checkpoint-index="index"
          :checkpoint="checkpoint"
          :findings="getCheckpointFindings(checkpoint.id)"
        />
        <hr>
      </div>
    </div>
  </div>  
</div>
</template>
<script>
import { mapGetters } from 'vuex'
import CheckpointFindings from './Checkpoint/Findings.vue'

export default {

  components: {
    CheckpointFindings
  },

  methods: {
    getCheckpointFindings(checkpointId) {
      return this.findings.filter(finding => finding.checkpoint_id === checkpointId)
    }
  },
  
  computed: {
    ...mapGetters('audit', [
      'audit',
      'findings'
    ]),
    
    sectionsWithFindings() {
      return this.audit.standard.sections.filter(section => {
        let sectionCheckpointIds = section.checkpoints.map(checkpoint => checkpoint.id)
        let findingCheckpointIds = this.findings.map(finding => finding.checkpoint_id)
        return sectionCheckpointIds.some(checkpointId => findingCheckpointIds.includes(checkpointId))
      })
    }
  }

}
</script>